import { Lang, getTranslation } from "@/data/translation";
import {
  PortfolioReturns,
  PortfolioReturnsPeriod,
} from "@/services/custom-portfolio/custom-portfolio-returns";
import { ChartData } from "chart.js";

export const extractPortfolioReturnsData = ({
  data,
  lang,
  period,
}: {
  data: PortfolioReturns;
  lang: Lang;
  period: PortfolioReturnsPeriod;
}): ChartData<"bar" | "line"> | null => {
  if (
    !data.cumulativeReturns ||
    !data.yearlyReturns ||
    data.cumulativeReturns.length === 0 ||
    data.yearlyReturns.length === 0
  )
    return null;

  const { t } = getTranslation({ lang });
  const chartData = data[period];
  const labels = chartData.map((item) => item.date);
  const portfolioData = chartData.map((item) => item.portfolioReturn ?? 0);
  const benchmarkData = chartData.map((item) => item.benchmarkReturn ?? 0);

  return {
    labels,
    datasets: [
      {
        label: t.customPortfolioReturns.portfolioReturn,
        data: portfolioData,
        borderColor: "rgb(75, 192, 192)",
        backgroundColor: "rgb(75, 192, 192)",
        tension: 0.1,
        pointRadius: 0,
      },
      {
        label: t.customPortfolioReturns.benchmarkReturn,
        data: benchmarkData,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgb(255, 99, 132)",
        tension: 0.1,
        pointRadius: 0,
      },
    ],
  };
};
